import { Box, Stack, Text } from 'braid-design-system';
import React, { type ReactNode } from 'react';
import { v4 as uid } from 'uuid';

import { content } from './index.css';

interface Props {
  loading: boolean;
  children: ReactNode;
  height?: number;
  lines: number[] | string[];
  offset?: boolean;
}

const defaultHeight = 16;

export const ContentLoader = (props: Props) => {
  const { children, height, lines, loading, offset = false } = props;

  const id = uid();

  return (
    <>
      {loading ? (
        <Stack space="small">
          {lines.map((line, i) => (
            <Text key={`loader-${id}-${i}`} baseline={offset}>
              <Box
                className={content}
                style={{ height: height ?? defaultHeight, width: line }}
              />
            </Text>
          ))}
        </Stack>
      ) : (
        children
      )}
    </>
  );
};
